export default __webpack_public_path__ + "static/media/nodejs-icon.b1379f6c.svg";